import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Modifiable extends Vue {
    @Prop({ type: String })
    modifier!: string

    get modifiers(): string[] {
        return (this.modifier || '').split(' ')
    }
}
